import * as XLSX from "exceljs";

const downloadFile = (buffer, fileName) => {
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;
  link.click();
};

export const exportProductsToTucan = async (
  products,
  categoriesById,
  restaurantName
) => {
  const workbook = new XLSX.Workbook();

  // Hoja 1: Categorías (encabezados EXACTOS, "Descripcion" sin tilde)
  const categoriasSheet = workbook.addWorksheet("Categorías");
  categoriasSheet.columns = [
    { header: "SKU", key: "sku" },
    { header: "Nombre", key: "nombre" },
    { header: "Descripcion", key: "descripcion" },
    { header: "Indicadores", key: "indicadores" },
    { header: "URL Imagen", key: "urlImagen" },
  ];

  // Una fila por categoría DISTINTA usada por los productos exportados (dedupe por id)
  const seenCategoryIds = new Set();
  products.forEach((product) => {
    (product.categories ?? []).forEach((categoryId) => {
      if (seenCategoryIds.has(categoryId)) return;
      seenCategoryIds.add(categoryId);
      const category = categoriesById[categoryId];
      if (!category) return;
      categoriasSheet.addRow({ nombre: category.name });
    });
  });

  // Hoja 2: Items (encabezados EXACTOS, "Descripción" CON tilde)
  const itemsSheet = workbook.addWorksheet("Items");
  itemsSheet.columns = [
    { header: "Categoría", key: "categoria" },
    { header: "SKU", key: "sku" },
    { header: "Nombre", key: "nombre" },
    { header: "Descripción", key: "descripcion" },
    { header: "Tamaño", key: "tamano" },
    { header: "Precio", key: "precio" },
    { header: "Indicadores", key: "indicadores" },
    { header: "Grupo de opcionales", key: "grupoOpcionales" },
    { header: "URL Imagen", key: "urlImagen" },
    { header: "Cantidad Máxima", key: "cantidadMaxima" },
  ];

  products.forEach((product) => {
    const firstCategoryId = product.categories?.[0];
    const categoryName = categoriesById[firstCategoryId]?.name ?? "";
    itemsSheet.addRow({
      categoria: categoryName,
      nombre: product.name,
      descripcion: product.description,
      precio: product.price,
      urlImagen: product.images?.[0]?.url ?? "",
    });
  });

  // Hoja 3: Opcionales (solo encabezados, sin filas)
  const opcionalesSheet = workbook.addWorksheet("Opcionales");
  opcionalesSheet.columns = [
    { header: "Nombre Grupo", key: "nombreGrupo" },
    { header: "Selección Mínima", key: "selMin" },
    { header: "Selección Máxima", key: "selMax" },
    { header: "Obligatoria", key: "obligatoria" },
    { header: "Selección Múltiple", key: "selMultiple" },
    { header: "Opcional", key: "opcional" },
    { header: "Precio", key: "precio" },
    { header: "Descripción", key: "descripcion" },
  ];

  const buffer = await workbook.xlsx.writeBuffer();
  downloadFile(buffer, `${restaurantName ?? "productos"}_products_tucan`);
};
